import { render, staticRenderFns } from "./ConstructionNewWrapper.vue?vue&type=template&id=6d1a12ca&scoped=true&lang=pug&"
import script from "./ConstructionNewWrapper.vue?vue&type=script&lang=ts&"
export * from "./ConstructionNewWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionNewWrapper.vue?vue&type=style&index=0&id=6d1a12ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a12ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
